export default __webpack_public_path__ + "static/media/Torpedo-3Closed.a7430542.jpg";